import { render, staticRenderFns } from "./RealnameAuth.vue?vue&type=template&id=01d4084a&scoped=true&"
import script from "./RealnameAuth.vue?vue&type=script&lang=js&"
export * from "./RealnameAuth.vue?vue&type=script&lang=js&"
import style0 from "./RealnameAuth.vue?vue&type=style&index=0&id=01d4084a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d4084a",
  null
  
)

export default component.exports